import { useCallback } from "react"
import { Box, Button, Flex, Image, Text, VStack } from "@chakra-ui/react"

import shieldIcon from "#/assets/shield.svg"
import ModalContainer from "#/shared/components/ModalContainer"
import { links } from "#/shared/constants"
import { MezoModalProps } from "#/shared/types"

export default function ErrorModal({
  isOpen,
  onClose,
  shouldContactSupport = false,
}: MezoModalProps & {
  shouldContactSupport?: boolean
}) {
  const handleClose = useCallback(() => {
    if (shouldContactSupport) {
      window.open(links.DISCORD_SUPPORT, "_blank")
    }

    onClose()
  }, [onClose, shouldContactSupport])

  return (
    <ModalContainer isOpen={isOpen} onClose={onClose} width="522px">
      <Box bg="primary.white.100" rounded="24px" overflow="hidden">
        <VStack flexDir="column" bg="secondary.lightRed" p="48px 48px 24px">
          <Text
            variant="bodyLarge"
            fontSize="24px"
            color="primary.red.100"
            lineHeight="40px"
            mb="8px"
          >
            Something went wrong
          </Text>
          <Text
            textAlign="center"
            fontSize="18px"
            lineHeight="28px"
            fontWeight={400}
          >
            Please try again later.
          </Text>
          <Flex alignItems="center" gap="8px" mt="60px">
            <Image src={shieldIcon} />
            <Text variant="label" color="primary.black.70" lineHeight="20px">
              Your mats are reserved, you&apos;ll be able to claim shortly.
            </Text>
          </Flex>
        </VStack>
        <VStack m="48px 0" gap="24px">
          <Text textAlign="center" fontSize="18px" fontWeight={400}>
            {shouldContactSupport ? (
              <>
                If the problem continues, you can contact
                <br />
                Mezo Support on Discord
              </>
            ) : (
              <>
                You can close this window.
                <br />A message will let you know when to try again.
              </>
            )}
          </Text>
          <Button
            variant="primary"
            bg="primary.black.100"
            color="primary.white.100"
            p="16px 32px"
            borderRadius="48px"
            fontSize="16px"
            _hover={{ bg: "primary.black.90" }}
            onClick={handleClose}
            data-attr={
              shouldContactSupport ? "support-claim_error" : "error-claim_error"
            }
          >
            {shouldContactSupport ? "Contact support" : "Close"}
          </Button>
        </VStack>
      </Box>
    </ModalContainer>
  )
}
